import { Component } from "react";

import { MaintenanceRegisteredEntity } from "@app/maintenance";

interface MaintenancePropertyCardProps {
  children?: React.ReactNode;
  faIcon: string;
  isChecked: boolean;
  onMaintenancePropertyToggle?: (registeredEntity: MaintenanceRegisteredEntity) => void;
  registeredEntity: MaintenanceRegisteredEntity;
  subtitle: string;
  title: string;
}

class MaintenancePropertyCard extends Component<MaintenancePropertyCardProps, unknown> {
  constructor(props: MaintenancePropertyCardProps) {
    super(props);
  }

  public render() {
    return (
      <div className="col-md-4">
        <div className="card card-fluid maintenance-card">
          <div
            className={"card-header cursor-pointer p-3" + ((this.props.isChecked) ? " selected" : "")}
          >
            <h6 className="mb0">
              <i className={`fa fa-${this.props.faIcon} mr-1`} />
              {this.props.title}
            </h6>
            <div className="card-subtitle text-muted">
              {this.props.subtitle}
            </div>
          </div>
          <div
            className="card-body border-top cursor-pointer"
            onClick={this.props.onMaintenancePropertyToggle && (() => this.props.onMaintenancePropertyToggle(this.props.registeredEntity))}
          >
            <div className="card-text">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { MaintenancePropertyCard };
